import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import AnimatedSection from '../components/AnimatedSection';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Phone, Mail, MapPin, Clock } from 'lucide-react';
import PhoneReveal from '../components/PhoneReveal';
import ZohoFormEmbed from '../components/ZohoFormEmbed';

const ContactPage = () => {
  const contactInfo = [
    {
      icon: <Phone className="h-6 w-6" />,
      title: "Phone",
      details: [<PhoneReveal className="text-teal-700 underline hover:text-teal-900" />]
    },
    {
      icon: <Mail className="h-6 w-6" />,
      title: "Email",
      details: ["General: info[at]nursetechmedical.com", "Support: contact[at]nursetechmedical.com"]
    },
    {
      icon: <MapPin className="h-6 w-6" />,
      title: "Address",
      details: ["8 The Green, Ste A", "Dover, DE 19901"]
    },
    {
      icon: <Clock className="h-6 w-6" />,
      title: "Hours",
      details: ["Mon-Fri: 8AM-6PM EST"]
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-24">
        {/* Hero Section */}
        <section className="py-20 bg-gradient-to-b from-white to-gray-50">
          <div className="container mx-auto px-4">
            <AnimatedSection animation="fade-up">
              <div className="text-center max-w-4xl mx-auto">
                <h1 className="text-4xl lg:text-5xl font-bold mb-6" style={{ color: '#214140' }}>
                  Contact Us
                </h1>
                <p className="text-xl text-gray-600 leading-relaxed">
                  Get in touch with our team. We're here to help you 
                  implement Cordflex® in your ICU and answer any questions you may have.
                </p>
              </div>
            </AnimatedSection>
          </div>
        </section>

        {/* Contact Information */}
        <section className="py-20" style={{ backgroundColor: '#DFEAF0' }}>
          <div className="container mx-auto px-4">
            <AnimatedSection animation="fade-up">
              <div className="text-center mb-16">
                <h2 className="text-3xl lg:text-4xl font-bold mb-4" style={{ color: '#214140' }}>
                  Get in Touch
                </h2>
                <p className="text-xl text-gray-600 max-w-2xl mx-auto">
                  Multiple ways to reach our team
                </p>
              </div>
            </AnimatedSection>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {contactInfo.map((info, index) => (
                <AnimatedSection key={index} animation="fade-up" delay={index * 100}>
                  <Card className="bg-white shadow-lg hover:shadow-xl transition-shadow duration-300 h-full">
                    <CardContent className="p-6 text-center">
                      <div className="flex justify-center mb-4">
                        <div className="p-3 rounded-full" style={{ backgroundColor: '#8BBAB8', color: 'white' }}>
                          {info.icon}
                        </div>
                      </div>
                      <h3 className="text-xl font-bold mb-3" style={{ color: '#214140' }}>
                        {info.title}
                      </h3>
                      {info.details.map((detail, detailIndex) => (
                        <p key={detailIndex} className="text-gray-600 mb-1">
                          {detail}
                        </p>
                      ))}
                    </CardContent>
                  </Card>
                </AnimatedSection>
              ))}
            </div>
          </div>
        </section>

        {/* Form Section (Zoho Forms) */}
        <section className="py-20 bg-white">
          <div className="container mx-auto px-4">
            <div className="max-w-2xl mx-auto">
              <AnimatedSection animation="fade-up" disableOnMobile>
                <Card className="shadow-xl">
                  <CardContent className="p-2 sm:p-4">
                    <ZohoFormEmbed
                      form="ContactForm"
                      perma="GDzV7beeMrPB8wp84O1C6pde5uqhm8uzAlk7Tdu29DU"
                      height="1339px"
                      title="Contact Form"
                    />
                  </CardContent>
                </Card>
              </AnimatedSection>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20" style={{ backgroundColor: '#273139' }}>
          <div className="container mx-auto px-4">
            <AnimatedSection animation="fade-up">
              <div className="text-center max-w-3xl mx-auto">
                <h2 className="text-3xl lg:text-4xl font-bold mb-6 text-white">
                  Ready to Transform Your ICU?
                </h2>
                <p className="text-xl text-gray-300 mb-8 leading-relaxed">
                  Join hundreds of healthcare professionals who are already using Cordflex to improve patient care and streamline workflows.
                </p>
                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                  <Button
                    onClick={() => window.location.href = '/sample-request'}
                    className="px-8 py-4 text-lg font-semibold hover:opacity-90 transition-opacity duration-200"
                    style={{ backgroundColor: '#8BBAB8', color: 'white' }}
                  >
                    Request a Sample
                  </Button>
                  <Button
                    onClick={() => window.location.href = '/trial-request'}
                    className="px-8 py-4 text-lg font-semibold hover:opacity-90 transition-opacity duration-200"
                    style={{ backgroundColor: '#1F8051', color: 'white' }}
                  >
                    Request a Trial
                  </Button>
                </div>
              </div>
            </AnimatedSection>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default ContactPage;